const updates = [
  { date: '07-28', title: '《剑与魔法录》第128话更新', type: '更新' },
  { date: '07-28', title: '《甜蜜陷阱》最终话发布，全篇完结', type: '完结' },
  { date: '07-27', title: '新番《暗夜侦探》第二季正式上线', type: '新番' },
  { date: '07-27', title: '国漫专区新增5部国产漫画推荐', type: '上架' },
  { date: '07-26', title: '《异界召唤师》突破百万阅读量', type: '里程碑' },
  { date: '07-26', title: '暑期阅读季专题活动上线', type: '活动' },
  { date: '07-25', title: '悬疑推理分类漫画全面优化分类', type: '优化' },
  { date: '07-25', title: '移动端阅读体验升级，加载速度提升30%', type: '升级' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">最新动态</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">漫蛙漫画网的最新更新、上架与平台动态速览</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className="relative mb-6 last:mb-0"
              >
                <div className={`absolute -left-[33px] w-4 h-4 rounded-full border-2 flex-shrink-0 ${
                  item.type === '新番' || item.type === '上架'
                    ? 'bg-primary-100 border-primary-500'
                    : item.type === '完结'
                    ? 'bg-accent-100 border-accent-500'
                    : 'bg-background-100 border-background-300'
                }`}></div>

                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 font-medium bg-background-50 px-2 py-0.5 rounded whitespace-nowrap flex-shrink-0 w-fit">
                    {item.date}
                  </span>
                  <span className={`text-[10px] font-medium px-2 py-0.5 rounded whitespace-nowrap flex-shrink-0 w-fit ${
                    item.type === '新番' || item.type === '上架'
                      ? 'bg-primary-100 text-primary-700'
                      : item.type === '完结'
                      ? 'bg-accent-100 text-accent-700'
                      : item.type === '里程碑'
                      ? 'bg-amber-100 text-amber-700'
                      : item.type === '活动'
                      ? 'bg-emerald-100 text-emerald-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.type}
                  </span>
                  <span className="text-sm text-foreground-700 font-medium">{item.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}